module.exports = __webpack_public_path__ + "img/Champetre.589679f.jpg";